import React from 'react'
import useTransaction from 'tennders-transactions/hooks/useTransaction'
import { STATUS_WAITING_FOR_OFFER } from 'tennders-stracture/libs/constants'
import FirstOfferToLoad from './FirstOfferToLoad'
import FirstOfferToTruck from './FirstOfferToTruck'

const FirstOffer = () => {
  const { transaction, fetchingTransaction } = useTransaction()

  if (transaction?.isMine || transaction?.status?.label !== STATUS_WAITING_FOR_OFFER) {
    return null
  }

  if (fetchingTransaction) {
    return null
  }

  return transaction?.matchedLoad
    ? <FirstOfferToLoad transaction={transaction} />
    : <FirstOfferToTruck transaction={transaction} />
}

export default React.memo(FirstOffer)
